import { useState } from 'react';
import { useSiteConfig, saveSiteConfig } from '../../../utils/siteConfig';
import { useQueue } from '../../../context/QueueContext';

const inputCls =
  'mt-1 h-12 w-full rounded-xl border border-input bg-white px-4 text-sm outline-none focus:border-navy focus:ring-2 focus:ring-navy/15';
const labelCls = 'block text-xs font-semibold uppercase tracking-wide text-muted-foreground';

function Field({ label, testid, value, onChange, placeholder, type = 'text' }) {
  return (
    <div>
      <label htmlFor={testid} className={labelCls}>{label}</label>
      <input id={testid} data-testid={testid} type={type} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className={inputCls} />
    </div>
  );
}

export default function StoreDataSection({ flash }) {
  const { user } = useQueue();
  const cfg = useSiteConfig();
  const [form, setForm] = useState({ ...cfg.store });
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    let digits = form.whatsapp.replace(/\D/g, '');
    if (digits && !digits.startsWith('55')) digits = `55${digits}`;
    try {
      await saveSiteConfig({ store: { ...form, whatsappDigits: digits } }, user, 'Alterou os dados da loja.');
      flash('Dados da loja salvos.');
    } catch (e) {
      flash(e.message || 'Falha ao salvar os dados da loja.');
    }
  };

  return (
    <section className="rounded-2xl border border-navy/10 bg-white p-5" data-testid="pers-store-section">
      <h3 className="font-serif text-xl text-navy">Dados da Loja</h3>
      <p className="mt-1 text-sm text-muted-foreground">
        Estes dados alimentam automaticamente a barra superior, o rodapé, a Home e a página Nossa Loja.
      </p>

      <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Field label="Nome da loja" testid="pers-store-name" value={form.name} onChange={set('name')} />
        <Field label="Telefone" testid="pers-store-phone" value={form.phone} onChange={set('phone')} placeholder="(41) 3224-4723" />
        <Field label="WhatsApp" testid="pers-store-whatsapp" value={form.whatsapp} onChange={set('whatsapp')} placeholder="(41) 99999-9999" />
        <Field label="Endereço" testid="pers-store-address" value={form.address} onChange={set('address')} placeholder="Praça Osório, 15" />
        <Field label="Cidade/UF" testid="pers-store-city" value={form.cityUf} onChange={set('cityUf')} placeholder="Centro · Curitiba/PR" />
        <Field label="Instagram (URL completa)" testid="pers-store-instagram" value={form.instagram} onChange={set('instagram')} placeholder="https://instagram.com/sualoja" />
        <Field label="Facebook (URL completa)" testid="pers-store-facebook" value={form.facebook} onChange={set('facebook')} placeholder="https://facebook.com/sualoja" />
        <div>
          <label htmlFor="pers-store-hours" className={labelCls}>Horário de atendimento (exibido ao cliente)</label>
          <textarea id="pers-store-hours" data-testid="pers-store-hours" value={form.hours} onChange={(e) => set('hours')(e.target.value)} rows={2} className="mt-1 w-full rounded-xl border border-input bg-white px-4 py-3 text-sm outline-none focus:border-navy" />
        </div>
      </div>
      <div className="mt-4">
        <label htmlFor="pers-store-note" className={labelCls}>Texto complementar de atendimento</label>
        <textarea id="pers-store-note" data-testid="pers-store-note" value={form.attendanceNote} onChange={(e) => set('attendanceNote')(e.target.value)} rows={2} className="mt-1 w-full rounded-xl border border-input bg-white px-4 py-3 text-sm outline-none focus:border-navy" />
      </div>

      <p className="mt-3 rounded-xl bg-navy-light/60 p-3 text-xs text-navy" data-testid="pers-store-hours-note">
        O horário acima é o horário PÚBLICO da loja. A regra de acesso dos vendedores ao painel
        (seg–sex 09:00–18:30, sáb 09:00–13:30, domingo bloqueado) é uma configuração diferente e não é alterada aqui.
      </p>

      <button type="button" onClick={save} data-testid="pers-store-save" className="mt-4 w-full rounded-full bg-navy px-6 py-3.5 text-sm font-semibold text-white hover:bg-navy-hover sm:w-auto">
        SALVAR ALTERAÇÕES
      </button>
    </section>
  );
}
